import * as t from '../types';
import {GET_TUTOR_AVAILABILITY_FAILED, GET_TUTOR_AVAILABILITY_REQUEST, GET_TUTOR_AVAILABILITY_SUCCESS} from "../types";

const initialState = {
    data: '',
    loading: false,
    error: ''
};

export default function tutorAvailabilityReducer(state = initialState, action) {
    const {type, payload} = action;
    switch (type) {
        case t.GET_TUTOR_AVAILABILITY_REQUEST:
            return {
                ...state,
                loading: true
            };
        case t.GET_TUTOR_AVAILABILITY_SUCCESS:
            return {
                ...state,
                loading: false,
                data: payload.data
            };
        case t.GET_TUTOR_AVAILABILITY_FAILED:
            return {
                ...state,
                error: payload,
                loading: false
            };
        default:
            return state;
    }
}
